import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Modal } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';
import Connection from '../../Calls';
import Backend from '../../Backend';

import Check from '../../Images/check.svg';
import CheckCorrect from '../../Images/check-correct.svg';

export default class ChangePassModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",

      currentPass:'',

      validatePass8: false,
      validatePassMayus: false,
      validatePassMinus: false,
      validatePassDigit: false,
      validatePassEspecial: false,
      validatePassSame: false,

      reCaptcha: '',
      showLoad: false,
    }
  }

  componentWillMount() {
    this.bQk7VZx7();
  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {
      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  changePassword(){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    let combination2 = Connection.RThzHrsb("XWBX203")
    let whiskas = Connection.RThzHrsb(self.state.currentPass);
    let pedigree = Connection.RThzHrsb(self.state.newPassword);

    self.setState({showLoad:true})

    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload;
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "1", whiskas, response => {
        var currentPassPayload = response.payload;
        Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "1", pedigree, response => {
          var newPassPayload = response.payload;
            Backend.ChangeMainPass(localStorage.getItem('email'),localStorage.getItem('token'),currentPassPayload.r03,newPassPayload.r03,this.state.reCaptcha,payload.r01,response =>{

              if (response.status.code === "0") {
                self.setState({showLoad:false})

                store.addNotification({
                  title: "Success!",
                  message: response.payload.message,
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });

                setTimeout(function () { self.props.handleChangeModal(false); }, 500);
              } else {
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                self.setState({ showLoad: false });
              }


            })

        })

      })

    })
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  validateNewPassword() {
    const self = this;

    if (self.state.newPassword.length >= 8) {
      self.setState({ validatePass8: true });
    } else {
      self.setState({ validatePass8: false });
    }

    if (/(?:.*[A-Z]){1}/.test(this.state.newPassword)) {
      self.setState({ validatePassMayus: true });
    } else {
      self.setState({ validatePassMayus: false });
    }

    if (/(?:.*[a-z]){1}/.test(this.state.newPassword)) {
      self.setState({ validatePassMinus: true });
    } else {
      self.setState({ validatePassMinus: false });
    }

    if (/(?:.*\d){1}/.test(this.state.newPassword)) {
      self.setState({ validatePassDigit: true });
    } else {
      self.setState({ validatePassDigit: false });
    }

    if (/[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\]\\]/gi.test(this.state.newPassword)) {
      self.setState({ validatePassEspecial: true });
    } else {
      self.setState({ validatePassEspecial: false });
    }

    if (this.state.newPassword === this.state.confirmPassword && this.state.newPassword !== "" && this.state.confirmPassword !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }

  }

  validateConfirmPassword() {
    const self = this;
    if (this.state.confirmPassword === this.state.newPassword && this.state.confirmPassword !== "" && this.state.newPassword !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }
  }

  render(){
    return(
      <Modal className='change-pass-modal' show={this.props.changeModal} onHide={()=>this.props.handleChangeModal(false)}>
        <Modal.Body>
          <div className="border-title-separator-container-left" style={{ width: "100%" }}>
            <p className="title-container-shadow">{this.props.traductions.settings.services.L_Passwor}</p>
          </div>
          <div>
            <Form.Group>
              <Form.Label className="label-modal">{this.props.traductions.settings.services.modalChangePass.L_current}</Form.Label>
              <Form.Control
                type="password"
                placeholder="********"
                className="input-signup"
                value={this.state.currentPass}
                onChange={(currentPass) => { this.setState({ currentPass: currentPass.target.value }) }}
              />
              <Form.Label className="label-modal">{this.props.traductions.settings.services.modalChangePass.L_new}</Form.Label>
              <Form.Control
                type="password"
                placeholder="********"
                className="input-signup"
                value={this.state.newPassword}
                onChange={(newPassword) => { this.setState({ newPassword: newPassword.target.value }) }}
                onKeyUp={() => { this.validateNewPassword() }}
              />
              <Form.Label className="label-modal">{this.props.traductions.settings.services.modalChangePass.L_confirm}</Form.Label>
              <Form.Control
                type="password"
                placeholder="********"
                className="input-signup"
                value={this.state.confirmPassword}
                onChange={(confirmPassword) => { this.setState({ confirmPassword: confirmPassword.target.value }) }}
                onKeyUp={() => { this.validateConfirmPassword() }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label className="label-modal">{this.props.traductions.settings.services.modalChangePass.L_requirements}</Form.Label>

                <div className="container-messages-signup">
                  <p className={!this.state.validatePass8 ? "label-validates" : "label-validates-correct"}>
                    <Image className="icono-check-text-password" src={!this.state.validatePass8 ? Check : CheckCorrect} />
                    {this.props.traductions.General.PassRequirements.req1}.
                    </p>
                  <p className={!this.state.validatePassMayus ? "label-validates" : "label-validates-correct"}>
                    <Image className="icono-check-text-password" src={!this.state.validatePassMayus ? Check : CheckCorrect} />
                    {this.props.traductions.General.PassRequirements.req2}.
                    </p>
                  <p className={!this.state.validatePassMinus ? "label-validates" : "label-validates-correct"}>
                    <Image className="icono-check-text-password" src={!this.state.validatePassMinus ? Check : CheckCorrect} />
                    {this.props.traductions.General.PassRequirements.req3}.
                    </p>
                  <p className={!this.state.validatePassDigit ? "label-validates" : "label-validates-correct"}>
                    <Image className="icono-check-text-password" src={!this.state.validatePassDigit ? Check : CheckCorrect} />
                    {this.props.traductions.General.PassRequirements.req4}.
                    </p>
                  <p className={!this.state.validatePassEspecial ? "label-validates" : "label-validates-correct"}>
                    <Image className="icono-check-text-password" src={!this.state.validatePassEspecial ? Check : CheckCorrect} />
                    {this.props.traductions.General.PassRequirements.req5}.
                    </p>
                  <p className={!this.state.validatePassSame ? "label-validates" : "label-validates-correct"}>
                    <Image className="icono-check-text-password" src={!this.state.validatePassSame ? Check : CheckCorrect} />
                    {this.props.traductions.General.PassRequirements.req6}.
                    </p>
                </div>
            </Form.Group>

            <div>
              <center style={{ marginBottom: 0 }}>
                {
                  (this.state.vertice) &&
                  <ReCAPTCHA
                    theme="light"
                    key="1"
                    sitekey={this.state.vertice}
                    onChange={this.handleChange.bind(this)}
                  />
                }
              </center>
            </div>


            <div>
              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button className="signup-button" variant="primary" onClick={() => { this.changePassword() }} disabled={this.state.showLoad}>
                  {
                    (this.state.showLoad)
                      ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showLoad} />
                    : this.props.traductions.settings.services.L_Passwor
                  }
                </Button>
              </div>
              <div style={{ marginTop: 0, textAlign: "center" }}>
                <Button className="label-modal-link" variant="link" onClick={() => { this.props.handleChangeModal(false) }}>{this.props.traductions.settings.services.modalChangePass.btn_Cancel}</Button>
              </div>
            </div>

          </div>

        </Modal.Body>
      </Modal>
    )
  }
}
